import type { BattleMode } from "@loot-os/api-contract";

export const BATTLE_MODE_LABEL: Record<BattleMode, string> = {
  standard: "Standard",
  crazy: "Crazy",
};

export const BATTLE_MODE_RULE: Record<BattleMode, string> = {
  standard: "Highest total value wins everything",
  crazy: "Lowest total value wins everything",
};
